import { useEffect,useState } from "react"
import axios from "axios"
import { HashLoader } from "react-spinners";

export default function AlreadyLogged(){

    const rootUrl = "http://localhost:3000";
    const localrootUrl = "https://ahkserver.onrender.com";
    const [user,setUser]=useState();
    const [loading,setLoading]=useState(true);

    useEffect(()=>{
        const fetchusername = async ()=>{
            const username = await axios.get(`${localrootUrl}/getuser`,{withCredentials:true});
            if(username){
                setUser(username.data);
                console.log(user);
                setLoading(false);
            }
        }
        fetchusername();
    },[])
    return <div className="already">
        <h1 style={{color:"rgb(72, 141, 72)"}}>You are Logged in</h1>
        <div className="subalready">
           <p>Username:</p> 
           <p className="customsub">{user?user.name:<HashLoader loading={loading}/>}</p>
        </div>
        <div className="subalready">
            <p>Email:</p>
            <p className="customsub">{user?user.email:<HashLoader loading={loading}/>}</p>
        </div>
    </div>
}